import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CervicalSpondylosisPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Cervical Spondylosis</h1>
        <section className="mb-8">
          <p>Cervical spondylosis is a common, age-related condition affecting the neck's spinal discs. It can cause neck pain, stiffness, and sometimes nerve-related symptoms. While it's a natural part of aging, you don't have to live with discomfort—herbal therapies can help restore mobility and ease pain.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Wear and tear of spinal discs</li>
            <li>Dehydration of discs</li>
            <li>Bone spurs</li>
            <li>Previous neck injuries</li>
            <li>Poor posture</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Neck pain and stiffness</li>
            <li>Headaches</li>
            <li>Pain radiating to shoulders or arms</li>
            <li>Tingling or numbness in arms or hands</li>
            <li>Muscle weakness</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We combine herbal oils, gentle therapies, and targeted exercises to reduce inflammation, relax muscles, and improve neck mobility. Our holistic care addresses both the symptoms and underlying causes for lasting relief.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Non-invasive pain relief</li>
            <li>Improves flexibility and posture</li>
            <li>Reduces inflammation naturally</li>
            <li>Personalized care for every patient</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Practice neck stretches and yoga</li>
            <li>Maintain good posture</li>
            <li>Use supportive pillows</li>
            <li>Take regular breaks from screens</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment reverse cervical spondylosis?</strong>
            <p>A: While it can't reverse aging, it can greatly reduce symptoms and improve quality of life.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for seniors?</strong>
            <p>A: Yes, our treatments are gentle and suitable for all ages.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How long before I see results?</strong>
            <p>A: Many patients feel relief within a few sessions.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Regain neck comfort—book your herbal therapy session today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default CervicalSpondylosisPage; 